import React from "react";

export default function NotAuthorized(props) {
    return (
        <div className="listingPageCardNoData">
            <img alt="grounded" src="noDataFound.jpeg" className="nodataImage" />
            <span className="nodataText">Not Authorized</span>
        </div>
    )
}
